import type { ColorMode } from "./types";

export const defaultColorMode: ColorMode = "light";
